import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ["consent"]

	showConsent() {
		this.consentTarget.classList.remove("hidden")
	}
}
